<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Permission"
            bc3="Update"
            path="permissions"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="name-icon">Name</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <input-->
<!--                                  type="text"-->
<!--                                  v-model="name"-->
<!--                                  id="name-icon"-->
<!--                                  class="form-control"-->
<!--                                  :class="-->
<!--                                  errorBag.has('name') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                                  name="name"-->
<!--                                  placeholder="Name"-->
<!--                                  v-validate="'required'"-->
<!--                              />-->
<!--                              <small-->
<!--                                  v-show="errorBag.has('name')"-->
<!--                                  class="invalid-feedback"-->
<!--                              >{{ "*" + errorBag.first("name") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="dsname-icon">Slug</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <input-->
<!--                                  type="text"-->
<!--                                  v-model="slug"-->
<!--                                  id="dsname-icon"-->
<!--                                  class="form-control"-->
<!--                                  :class="-->
<!--                                  errorBag.has('slug') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                                  name="slug"-->
<!--                                  placeholder="slug"-->
<!--                                  v-validate="'required'"-->
<!--                              />-->
<!--                              <small-->
<!--                                  v-show="errorBag.has('slug')"-->
<!--                                  class="invalid-feedback"-->
<!--                              >{{ "*" + errorBag.first("slug") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Description</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="description"
                                  class="form-control"
                                  name="description"
                                  placeholder="description"
                                  v-validate="'required'"
                              />

                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Status</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <select-->
<!--                                  v-model="status"-->
<!--                                  name="status"-->
<!--                                  v-validate="'required'"-->
<!--                                  class=form-control-->
<!--                                  :class="-->
<!--                                  errorBag.has('status') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                              >-->
<!--                                <option value=""-->
<!--                                >Please Select Status-->
<!--                                </option>-->
<!--                                <option :value="1"-->
<!--                                >Active-->
<!--                                </option>-->
<!--                                <option :value="0"-->
<!--                                >Inactive-->
<!--                                </option>-->
<!--                              </select>-->
<!--                              <small-->
<!--                                  v-show="errorBag.has('status')"-->
<!--                                  class="invalid-feedback"-->
<!--                              >{{ "*" + errorBag.first("status") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Features</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                  v-model="selectedFeature"
                                  name="status"
                                  class="form-control"


                              >
                                <option :value="null"
                                >Please Select Feature
                                </option>
                                <optgroup :label="feature.name" v-for="(feature,index)  in featureList">
                                  <option :value="featureChilds.id" :key="featureChildsIndex" v-for="(featureChilds,featureChildsIndex)  in feature['features']"
                                  >{{featureChilds.name}}
                                  </option>
                                </optgroup>

                              </select>
                              <small
                                  v-show="errorBag.has('status')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("status") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-9 offset-sm-3 text-right d-flex">
                            <button
                                type="button"
                                class="btn btn-primary mr-1 d-flex"
                                @click="sendCall"
                                :disabled="loading"
                            >
                              <Loader :loading="loading" :size="size"></Loader>
                              Save
                            </button>
                            <button
                                type="button"
                                class="btn btn-gradient-secondary"
                                @click="$emit('back')"
                            >
                              Back
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {
    this.getAllFeatures()
    let permissionUpdateData = this.$store.getters.getByKey("permissionUpdate");

    if (permissionUpdateData) {
      this.index = permissionUpdateData.index;
      this.id = permissionUpdateData.id;
      // this.name = permissionUpdateData.row.name;
      // this.slug = permissionUpdateData.row.slug;
      this.description = permissionUpdateData.description;
      // this.status = permissionUpdateData.row.status;
      this.selectedFeature = permissionUpdateData.feature_id;
      // this.defaultStatus = permissionUpdateData.row.is_default;
    }

  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      slug: "",
      description: "",
      selectedFeature: null,
      status: "",
      type: "",
      featureList:[],
      defaultStatus:0,
      loading: false,
      size: "10px",
      options: [
        { id: 1, text: "Admin" },
        { id: 2, text: "User" },
        { id: 3, text: "Merchant" }
      ]
    };
  },

  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {

        if(valid){
          let data = {
            id:this.id,
            // name: this.name,
            description: this.description,
            // status: this.status,
            // slug: this.slug,
            feature_id:this.selectedFeature
          }

          this.loading = true

          this.makeRequest("post", "v1/update-permission", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      let responseData = callResponse.response.data.data;
                      let storeData = this.$store.getters.getByKey("permissionUpdate");
                      let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                      let rowProp = {
                        ...storeData,
                        ...responseData
                      }
                      rawdata[storeData.idx] = rowProp
                      this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                      this.$emit('back')
                      return
                    }
                  }
                }
                this.loading = false;
              }
          );
        }

      });
    },
    getAllFeatures(){
      this.makeRequest(
          "post",
          "v1/get-admin-dashboard-feature",
          {
            flag:'all'
          },
          {},
          false,
          false,
          [205]
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.featureList = callResponse.response.data.data;

          }
        }
      });
    }
  }
};
</script>

